import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

export const PageWrapper = styled.div`
  --pad: clamp(56px, 7vw, 96px);
  --gap-h2: clamp(40px, 5vw, 56px);
  --numfs: clamp(32px, 3.4vw, 40px);
  --wide: 1200px;
  --read: 960px;
  --gut: 40px;

  ${screen.md} {
    --gut: 48px;
  }

  ${screen.lg} {
    --gut: 80px;
  }

  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
`;
